import { ProtectedRoute } from "./";
import { MainLayout } from "../layout";

const PrivateRouteWithLayout = ({ children }) => {
	return (
		<ProtectedRoute>
			<MainLayout>{children}</MainLayout>
		</ProtectedRoute>
	);
};

export default PrivateRouteWithLayout;
